import { createContext, useContext } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarCollapseState {
  collapsed: boolean;
  toggle: () => void;
}

/**
 * Свёрнут ли боковой навбар десктопа (только иконки). Выбор помним между
 * сессиями — это настройка человека, а не состояние экрана.
 */
export const useSidebarCollapseStore = create<SidebarCollapseState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggle: () => set((state) => ({ collapsed: !state.collapsed })),
    }),
    {
      name: 'sidebar-collapse-storage',
      partialize: (state) => ({ collapsed: state.collapsed }),
    }
  )
);

/**
 * Свёрнут ли сайдбар, внутри которого рендерится пункт. Контекст, а не стор
 * напрямую: вне DesktopSidebar те же пункты всегда развёрнуты.
 */
export const SidebarCollapsedContext = createContext(false);

export const useSidebarCollapsed = () => useContext(SidebarCollapsedContext);
